import React from 'react';

const VigasPVCSector = () => {
  const colores = [
    { name: 'Cedro', color: '#8B5E3C' },
    { name: 'Roble', color: '#A77B50' },
    { name: 'Teka', color: '#7E6651' },
  ];

  const tamanos = [
    { medida: '2.95 m × 5 cm × 5 cm', peso: '1.6 kg por pieza' },
    { medida: '2.95 m × 7.5 cm × 5 cm', peso: '2.6 kg por pieza' },
    { medida: '2.95 m × 10 cm × 5 cm', peso: '3 kg por pieza' },
  ];

  const especificaciones = [
    { label: 'Material', value: 'PVC de alta densidad' },
    { label: 'Tamaños disponibles', value: '5×5 cm / 7.5×5 cm / 10×5 cm' },
    { label: 'Largo por pieza', value: '2.95 m' },
    { label: 'Peso por pieza', value: '1.6 kg / 2.6 kg / 3 kg según tamaño' },
    { label: 'Uso', value: 'Exclusivamente en interior' },
    { label: 'Vida útil', value: '10 años' },
    { label: 'Garantía', value: '1 año por defecto de fábrica' },
    { label: 'Limpieza', value: 'Paño húmedo. Evitar líquidos clorados y ácidos rebajados' },
  ];

  const caracteristicas = [
    {
      title: 'Sin Mantenimiento',
      description: 'No requiere barniz, pintura ni tratamientos adicionales para mantener su apariencia.',
      delay: '100ms',
    },
    {
      title: 'Instalación Inmediata',
      description: 'Fijación limpia con tornillos o adhesivo, sin obra, demolición ni escombro.',
      delay: '200ms',
    },
    {
      title: 'Funcionalidad',
      description: 'Estructura hueca ideal para ocultar cables, tuberías o conductos discretamente.',
      delay: '300ms',
    },
    {
      title: 'Resistencia a Plagas',
      description: 'Libre de termitas, insectos y hongos, sin necesidad de tratamientos químicos.',
      delay: '400ms',
    },
    {
      title: 'Retardante al Fuego',
      description: 'El PVC es autoextinguible y no propaga la llama, sumando seguridad al espacio.',
      delay: '500ms',
    },
    {
      title: 'Durabilidad y Garantía',
      description: '10 años de vida útil en interiores y 1 año de garantía por defecto de fábrica.',
      delay: '600ms',
    },
  ];

  return (
    <section id="vigas-pvc" className="pb-5 pb-lg-7 bg-light">
      <div className="container">
        <div className="row align-items-center mb-5">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="title-style2 mb-1-6">
              <h2 className="h1">Vigas de PVC decorativas para interiores</h2>
            </div>
            <p className="mb-2-2">
              Una alternativa ligera y decorativa para proyectos que buscan textura, facilidad de instalación
              y acabados realistas sin mantenimiento. Ideal para muros, techos, escaleras o separadores de ambientes.
            </p>

            <div className="p-4 bg-white rounded shadow-sm border mb-3">
              <h3 className="h5 mb-3">Tamaños disponibles</h3>
              <div className="table-responsive">
                <table className="table table-sm mb-0">
                  <thead>
                    <tr>
                      <th scope="col">Medida</th>
                      <th scope="col">Peso</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tamanos.map((t) => (
                      <tr key={t.medida}>
                        <td>{t.medida}</td>
                        <td>{t.peso}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="p-4 bg-white rounded shadow-sm border mb-4">
              <h3 className="h5 mb-3">Colores disponibles</h3>
              <ul className="list-unstyled d-flex flex-wrap gap-3 mb-0">
                {colores.map((color) => (
                  <li key={color.name} className="d-flex align-items-center">
                    <span
                      className="d-inline-block rounded-circle me-2"
                      style={{ width: '18px', height: '18px', backgroundColor: color.color }}
                      aria-hidden="true"
                    ></span>
                    <span>{color.name}</span>
                  </li>
                ))}
              </ul>
              <p className="text-muted mt-2 mb-0" style={{ fontSize: '0.85rem' }}>
                Los 3 tonos están disponibles en cada uno de los 3 tamaños.
              </p>
            </div>

            <a href="#contacto" className="butn-style4">
              <span>Cotizar Vigas de PVC</span>
            </a>
          </div>

          <div className="col-lg-6 d-flex align-items-center justify-content-center">
            <img
              src="/assets/img/productos/vigueta-wpc/vigas-pvc-producto.jpeg"
              alt="Vigas de PVC decorativas para interior"
              className="img-fluid"
              style={{
                borderRadius: '16px',
                width: '90%',
                height: 'auto',
                objectFit: 'cover',
              }}
            />
          </div>
        </div>

        <div className="row gx-3 gx-md-4 gy-3 gy-md-4 mb-5">
          {caracteristicas.map((item) => (
            <div key={item.title} className="col-12 col-md-6 col-xl-4">
              <article
                className="h-100 wow fadeInUp"
                data-wow-delay={item.delay}
                style={{
                  backgroundColor: '#fff',
                  border: '1px solid #eef0f2',
                  borderRadius: '12px',
                  padding: '1.5rem',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                }}
              >
                <div className="d-flex align-items-start" style={{ gap: '1rem' }}>
                  <span
                    className="d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      backgroundColor: '#eafaf1',
                      color: '#3cb878',
                    }}
                  >
                    <i className="fa-solid fa-check"></i>
                  </span>
                  <div>
                    <h4 className="mb-2" style={{ fontSize: '1.05rem' }}>
                      {item.title}
                    </h4>
                    <p className="mb-0 text-muted" style={{ fontSize: '0.95rem', lineHeight: 1.5 }}>
                      {item.description}
                    </p>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>

        <div className="row">
          <div className="col-12">
            <div className="bg-white rounded shadow-sm border p-4">
              <h3 className="h5 mb-3">Especificaciones técnicas</h3>
              <div className="table-responsive">
                <table className="table table-sm mb-0">
                  <tbody>
                    {especificaciones.map((esp) => (
                      <tr key={esp.label}>
                        <th scope="row" style={{ width: '40%' }}>
                          {esp.label}
                        </th>
                        <td>{esp.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VigasPVCSector;